import PropTypes from 'prop-types';

import noop from 'lodash/fp/noop';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { IngredientsDisclaimer } from 'Apps/Consultation/Components/IngredientsDisclaimer';
import BcorpPhilosophy from 'Apps/Prescription/Components/BcorpPhilosophy';

import ScaleLoader from 'Components/ScaleLoader';
import Spacer from 'Components/Spacer';

import consultationCategoryProp from 'PropTypes/consultationProps';
import IngredientShape from 'PropTypes/ingredientShape';

import { posology as content } from 'assets/content/consultation/consultation';

import QuestionLayout from '../QuestionLayout';
import IngredientList from './IngredientList';
import IngredientSection from './IngredientSection';

const getLabel = type => content.sectionLabels[type];

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledBcorpPhilosophy = styled(BcorpPhilosophy)`
  margin-top: 32px;
  background-color: ${theme.colors.neutral[300]};
`;

const Posology = ({ consultationCategory, name, posology, submit }) => (
  <QuestionLayout
    addFooter
    consultationCategory={consultationCategory}
    display="block"
    fixedCTA={false}
    showHeaderBackground
    showProgressTracker={false}
    submit={submit}
    subtitle={content.subtitle}
    title={content.title}
    usePadding={false}
  >
    {posology ? (
      <>
        {posology.map((block, key) => (
          <div key={String(`${block?.section}-${key}`)}>
            <Spacer axis="vertical" size={36} />
            {block?.ingredients?.length > 0 && (
              <IngredientSection
                isSupplement={block.section === 'supplement'}
                title={name && getLabel(block.section)(name)}
              >
                <IngredientList
                  ingredients={block.ingredients}
                  showIncludedIn={block?.section !== 'supplement'}
                />
              </IngredientSection>
            )}
          </div>
        ))}

        <IngredientsDisclaimer />

        <StyledBcorpPhilosophy />
      </>
    ) : (
      <LoaderWrapper>
        <ScaleLoader />
      </LoaderWrapper>
    )}
  </QuestionLayout>
);

Posology.defaultProps = {
  name: null,
  submit: noop,
  posology: null,
};

Posology.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  name: PropTypes.string,
  posology: PropTypes.arrayOf(
    PropTypes.shape({
      ingredients: PropTypes.arrayOf(IngredientShape),
      section: PropTypes.oneOf(['core', 'supplement']),
    })
  ),
  submit: PropTypes.func,
};

export default Posology;
